import { useEffect } from 'react';
import api from '../api/axios';

const AuthInitializer = () => {
    useEffect(() => {
        // Check if we have a token in localStorage
        const token = localStorage.getItem('token');
        if (token) {
            // Set the authorization header for all future requests
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }, []);

    return null; // This component doesn't render anything
};

export default AuthInitializer;